// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"80":"9452afc2","170":"7b4dc626","290":"852b7eb9","315":"015f559c","319":"9f0605d2","338":"2568c04d","418":"a22e8719","584":"8c4e7d4c","720":"9253a6c7","773":"5ffb76e5"}[chunkId] + ".chunk.js";
};